function addToStorage({ type, projectName, task }) {
  const data = getFromStorage();
  if (type === "project") {
    data.projects.push(projectName);
    data[projectName] = [];
  } else {
    if (data[projectName]) {
      data[projectName].push(task);
    }
  }
  saveToStorage(data);
}

function getFromStorage() {
  return (
    JSON.parse(localStorage.getItem("data")) || { projects: ["Home"], Home: [] }
  );
}

function updateStorage({ type, oldProjectName, newProjectName, task }) {
  console.log(type + oldProjectName + task);
  const data = getFromStorage();
  if (type === "project") {
    const i = data.projects.findIndex((project) => project === oldProjectName);
    data.projects[i] = newProjectName;
    data[newProjectName] = data[oldProjectName];
    delete data[oldProjectName];
  } else {
    console.log(data[oldProjectName]);
    const i = data[oldProjectName].findIndex((item) => item.id === task.id);
    data[oldProjectName][i] = task;
  }
  saveToStorage(data);
}

function deleteFromStorage({ type, projectName, task }) {
  const data = getFromStorage();
  if (type === "project") {
    data.projects = data.projects.filter((project) => project !== projectName);
    delete data[projectName];
  } else {
    data[projectName] = data[projectName].filter((item) => item.id !== task.id);
  }
  saveToStorage(data);
}

function saveToStorage(data) {
  localStorage.setItem("data", JSON.stringify(data));
}

export {
  addToStorage,
  getFromStorage,
  updateStorage,
  deleteFromStorage,
  saveToStorage,
};
